import {
  Alert,
  CardActions,
  CardHeader,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import { CalendarMonthOutlined } from "@mui/icons-material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import EducationForm from "./forms/EducationForm";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import { CVEducationService } from "../../../../service/CVEducationService";

const Etudes = () => {
  const [etudes, setEtudes] = useState([]);
  const [currentEtude, setCurrentEtudes] = useState(null);
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const query = useQuery();
  const id_ext_user = query.get("ref");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const handleCloseEducationForn = () => {
    setEducationFormDialogOpen(false);
    handleFetchEtudesList({
      id_ext_user: id_ext_user,
    });
  };

  const confirmDelete = (education) => {
    CVEducationService.delete({ id_etude: education.id_etude }).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchEtudesList({
          id_ext_user: id_ext_user,
        });
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleOpenEducationFormDialog = (education) => {
    setCurrentEtudes(education);
    setEducationFormDialogOpen(true);
  };

  const handleEditEducationFormDialog = (education) => {
    setCurrentEtudes(education);
    setEducationFormDialogOpen(true);
  };

  const handleDeleteEducationFormDialog = (education) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(education),
    );
  };

  const handleFetchEtudesList = (filtre) => {
    setFormLoading(true);
    CVEducationService.liste(filtre)
      .then((res) => {
        if (res && res.data) {
          setEtudes(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  useEffect(() => {
    handleFetchEtudesList({
      id_ext_user: id_ext_user,
    });
  }, []);

  return (
    <>
      <Toast />
      <DialogComponent />
      <Paper>
        <LinearProgress
          sx={{
            borderRadius: "3px 3px 0 0",
            display: formLoading ? "" : "none",
          }}
        />
        <EducationForm
          open={educationFormDialogOpen}
          onFormClose={handleCloseEducationForn}
          id_education={currentEtude ? currentEtude.id_etude : null}
        />
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Educations"
            titleTypographyProps={{fontWeight: "bold"}}
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  onClick={handleOpenEducationFormDialog}
                  text={"Ajouter"}
                  variant={"outlined"}
                />
              </Grid>
            }
          />
          {etudes.length > 0 ? (
            etudes.map((etude, index) => (
              <Grid key={index}>
                <ul>
                  <CardHeader
                    title={`${etude.diplome} | ${etude.filiere}`}
                    titleTypographyProps={{
                      color: "primary",
                      sx: {
                        fontSize: "20px",
                        fontWeight: "bold",
                        mb: 1,
                      },
                    }}
                    subheader={
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <CalendarMonthOutlined />
                            <span>
                              <b>Année :</b> <br />
                              {` ${etude.annee || ""}`}
                            </span>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <BusinessIcon />
                            <span>
                              <span>
                                <b>Etablissement :</b> <br />
                                {` ${etude.etablissement || ""}`}
                              </span>
                            </span>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <AccountTreeOutlinedIcon />
                            <span>
                              <b>Parcours :</b> <br />
                              {` ${etude.description || ""}`}
                            </span>
                          </Stack>
                        </Grid>
                      </Grid>
                    }
                  />
                  <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                    <AppButton
                      icon={<EditOutlined />}
                      onClick={(e) => handleEditEducationFormDialog(etude)}
                      text={"Modifier"}
                      variant={"outlined"}
                    />
                    <AppButton
                      icon={<DeleteOutline />}
                      onClick={(e) => handleDeleteEducationFormDialog(etude)}
                      text={"Supprimer"}
                      color={"warning"}
                      variant={"outlined"}
                    />
                  </CardActions>
                </ul>
                <Divider variant="middle" />
              </Grid>
            ))
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                {" "}
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default Etudes;
